import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import PackageContent from '../../shared/PackageContent';
import FormGigItem from '../../shared/FormGigItem';
import { getPackageById } from '../../../reducers/packages';
import { MP_CLICKED_COMPARE_PACKAGES } from '../../../utils/mixPanelEvents';
import { shouldShowSelectPackage } from '../../../utils/shouldShowSelectPackage';
import { isVoiceOver } from '../../../utils/packagesUtils';

import './style.scss';

class Content extends React.Component {

    constructor() {
        super();

        this.onCompareClick = this.onCompareClick.bind(this);
    }

    onCompareClick(e) {
        const { biEvents } = this.context;
        const { onComparePackagesClick } = this.props;

        e.preventDefault();

        // todo refactor to redux action so that a callback function won't be passed
        onComparePackagesClick();
        biEvents.sendMixPanelEvent({eventName: MP_CLICKED_COMPARE_PACKAGES});
    }

    render() {
        const {
            extraFast,
            id,
            currentPrice,
            inProgress
        } = this.props;

        const { general, currencyConverter } = this.context;
        const showSelectPackage = shouldShowSelectPackage(general);
        const formattedPrice = currencyConverter.convert(currentPrice);

        // todo: remove when VO package has a title
        const title = isVoiceOver(general) ? 'gig_page_perseus.packages.order_details' : '';

        return (
            <div className="content">
                {
                    extraFast &&
                    <FormGigItem packageId={id} id={extraFast.id} quantity={extraFast.currentValue}/>
                }
                <I18nProvider>
                    {({ i18n }) => (<PackageContent id={id} title={title ? i18n.t(title) : ''}/>)}
                </I18nProvider>
                <footer>
                    {showSelectPackage &&
                        <button type="submit" className={classNames('btn-lrg-standard', {'in-progress': inProgress})}>
                            <I18n k={'gig_page_perseus.packages.continue'}/>
                            <span> ({formattedPrice})</span>
                        </button>
                    }
                    <a href="#!" onClick={this.onCompareClick}>
                        <I18n k={'gig_page_perseus.packages_tabs.compare_packages'}/>
                    </a>
                </footer>
            </div>
        );
    }
}

Content.propTypes = {
    extraFast: PropTypes.object,
    id: PropTypes.number,
    currentPrice: PropTypes.number,
    inProgress: PropTypes.bool,
    onComparePackagesClick: PropTypes.func
};

Content.contextTypes = {
    biEvents: PropTypes.object,
    general: PropTypes.object,
    currencyConverter: PropTypes.object
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.id);

    return {
        ...packageData,
        onComparePackagesClick: ownProps.onComparePackagesClick
    };
};

Content.defaultProps = {
    onComparePackagesClick: () => true
};

const ContentConnect = connect(mapStateToProps)(Content);

const TabContent = ({id, onComparePackagesClick}) => (
    <ContentConnect id={id} onComparePackagesClick={onComparePackagesClick}/>
);

export { Content };
export default TabContent;
